<template>
  <teleport to="body">
    <div class="common-modal-wrap">
      <div class="common-shadow"  :class="{ 'z-show': isShow }"></div>
      <div class="common-modal" :class="{ remove: removeModal, 'z-show': isShow }">
        <div class="common-modal-title">{{ props.title }}</div>
        <div class="common-modal-content">
          <slot></slot>
          <!-- <div class="button-group flex-row-between-center">
            <div class="button cancel-btn" @click="cancelFn()">{{ $t('Common.Cancel') }}</div>
          </div> -->
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { watch } from 'vue';

const props = defineProps({
  isShow: Boolean,
  removeModal: Boolean,
  title: String,
  onOk: Function,
  onCancel: Function,
  okText: String
})


const emit = defineEmits(['update:isShow'])

const confirmFn: Function = (): void => {
  props.onOk && props.onOk()
}

const cancelFn: Function = (): void => {
  props.onCancel && props.onCancel()
  emit('update:isShow', false)
}

watch(()=>props.isShow,(newVal)=>{
  if (newVal) {
    document.body.style.overflow = "hidden"
  }else{
    document.body.style.overflow = "inherit"
  }
})
</script>

<style lang="scss" scoped>
.common-modal-wrap {

  // position: fixed;
  // width: 100%;
  // height: 100%;
  // left: 0;
  // right: 0;
  // top: 0;
  // bottom: 0;
  // z-index: -5;
  // &.z-show {
  //   z-index: 99;
  //   .common-shadow {
  //     display: block;
  //   }
  //   .common-modal {
  //     transform: translate(-50%, -50%) scale(1);
  //     &.remove {
  //       background: linear-gradient(180deg, #ffe1e1 0%, #feffff 19.79%, #ffffff 100%);
  //     }
  //   }
  // }
  .common-shadow {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(5px);
    transition: all 1s;
    display: none;
    z-index: 999;

    &.z-show {
      display: block;
    }
  }

  .common-modal {
    position: fixed;
    width: 320px;
    left: 50%;
    top: 50%;
    border-radius: 12px;
    background: #303342;
    transform: translate(-50%, -50%) scale(0);
    /* overflow: hidden; */
    z-index: 1000;
    transition: all .2s;
    color: #9C9CAA;
    padding: 16px;
    &.z-show {
      transform: translate(-50%, -50%) scale(1);
      transition: all 0.4s;
    }

    &.remove {
      background: linear-gradient(180deg, #ffe1e1 0%, #feffff 19.79%, #ffffff 100%);
    }

    &-title {
      display: flex;
      font-size: 18px;
      margin: 0 auto;
      text-align: center;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-weight: 500;
      /* border-bottom: 1px solid #f4f6f8; */
    }

    &-content {
      font-size: 14px;
      padding-top: 16px;
      font-weight: 400;
      line-height: 1.4;
      color: #9C9CAA;

      .button-group {
        margin-top: 30px;
        .button {
          width: 192px;
          height: 58px;
          text-align: center;
          line-height: 58px;
          font-size: 24px;
          font-weight: 500;
          margin: 0 auto;
          &.confirm-btn {
            background: #1088FF;
            color: #FFF;
          }
          &.cancel-btn {
            color: #fff;
            background: url(../../assets/btn-able.png);
            background-size: contain;
            background-repeat: no-repeat;
          }

          &.warn-btn {
            background: #ff5a81;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
